import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { f as r } from "../../../../../chunks/vec4f32.js";
import t from "../../../../webgl/BufferObject.js";
import "../../../../webgl/FramebufferObject.js";
import "../../../../../core/has.js";
import "../../../../webgl/checkWebGLError.js";
import "../../../../webgl/enums.js";
import "../../../../../chunks/builtins.js";
import { createProgram as e } from "../../../../webgl/programUtils.js";
import "../../../../webgl/Texture.js";
import s from "../../../../webgl/VertexArrayObject.js";
import i from "./WGLBrush.js";
import { background as o } from "../shaders/BackgroundPrograms.js";

var a = /*#__PURE__*/function (_i) {
  _inherits(a, _i);

  var _super = _createSuper(a);

  function a() {
    var _this;

    _classCallCheck(this, a);

    _this = _super.apply(this, arguments), _this._color = r(1, 0, 0, 1), _this._initialized = !1;
    return _this;
  }

  _createClass(a, [{
    key: "dispose",
    value: function dispose() {
      this._solidProgram && (this._solidProgram.dispose(), this._solidProgram = null), this._solidVertexArrayObject && (this._solidVertexArrayObject.dispose(), this._solidVertexArrayObject = null);
    }
  }, {
    key: "prepareState",
    value: function prepareState(_ref, t) {
      var r = _ref.context;
      r.setDepthWriteEnabled(!1), r.setDepthTestEnabled(!1), r.setStencilTestEnabled(!0), r.setBlendingEnabled(!1), r.setColorMask(!1, !1, !1, !1), r.setStencilOp(7680, 7680, 7681), r.setStencilWriteMask(255), r.setStencilFunctionSeparate(1032, 516, t.stencilRef, 255);
    }
  }, {
    key: "draw",
    value: function draw(r, t) {
      var e = r.context;
      this._initialized || this._initialize(e), e.bindVAO(this._solidVertexArrayObject), e.useProgram(this._solidProgram), this._solidProgram.setUniformMatrix3fv("u_dvsMat3", t.transforms.dvs), this._solidProgram.setUniform2fv("u_coord_range", [t.rangeX, t.rangeY]), this._solidProgram.setUniform1f("u_depth", 0), this._solidProgram.setUniform4fv("u_color", this._color), e.drawArrays(5, 0, 4), e.bindVAO();
    }
  }, {
    key: "_initialize",
    value: function _initialize(r) {
      if (this._initialized) return !0;
      var i = e(r, o);
      if (!i) return !1;
      var _a = {
        geometry: [{
          name: "a_pos",
          count: 2,
          type: 5120,
          offset: 0,
          stride: 2,
          normalized: !1,
          divisor: 0
        }]
      },
          n = new Int8Array([0, 0, 1, 0, 0, 1, 1, 1]),
          l = t.createVertex(r, 35044, n),
          d = new s(r, o.attributes, _a, {
        geometry: l
      });
      return this._solidProgram = i, this._solidVertexArrayObject = d, this._initialized = !0, !0;
    }
  }]);

  return a;
}(i);

export { a as default };